import { SafeHtmlPipe } from '@core/pipes/safe-html.pipe';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  output,
  ViewChild,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ClickOutsideDirective } from '@core/directives/click-outside.directive';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-captcha-overlay',
  imports: [
    SafeHtmlPipe,
    ClickOutsideDirective,
    ReactiveFormsModule,
  ],
  templateUrl: './captcha-overlay.component.html',
  styleUrl: './captcha-overlay.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class CaptchaOverlayComponent {
  @ViewChild('captchaInput') captchaInputElement!: ElementRef;

  captcha = input.required<string>();
  closeCaptchaOverlay = output<void>();
  verifyCaptcha = output<string>();

  captchaControl = new FormControl<string>('', [Validators.required]);
  captchaForm = new FormGroup({
    captchaControl: this.captchaControl,
  });

  constructor(private toastrService: ToastrService) {}

  ngAfterViewInit() {
    this.captchaInputElement.nativeElement.focus();
  }

  submitVerifyCaptcha() {
    if (this.captchaForm.valid) {
      const rawValue = this.captchaForm.getRawValue();
      this.verifyCaptcha.emit(rawValue.captchaControl!);
    } else {
      this.toastrService.error('Incorrect captcha.');
    }
  }
}
